require('jquery-confirm')

const defaultSettings = {
  animation        : 'zoom',
  backgroundDismiss: true,
  closeAnimation   : 'zoom',
  draggable        : false,
  smoothContent    : false,
  theme            : 'modern',
  typeAnimated     : false,
  useBootstrap     : false,
}

class deleteUserConfirm {
  _construct() {
    this.$btnsDeleteUser = document.querySelectorAll('.btn--delete-user');
  }

  _deleteUser($el) {
    const content = '<p>Esta acción no se puede deshacer</p>'

    let deleteUserOptions = {
      content: content,
      icon    : 'fas fa-exclamation-circle x:fs-50',
      title   : '¿Seguro de querer eliminar este usuario?',
      type    : 'blue',
      buttons : {
        confirm: {
          text: 'Aceptar',
          btnClass: 'btn btn-primary',
          action: function() {
            let $form = $el.closest('form');
            $form.submit();
          }
        },
        cancel: {
          text: 'Cancelar',
          btnClass: 'btn btn-secondary',
          action: function() {
            this.close();
          }
        }
      }
    }

    deleteUserOptions = $.extend(defaultSettings, deleteUserOptions)

    $.confirm(deleteUserOptions)
  }

  init() {
    this._construct();
    let self = this;

    self.$btnsDeleteUser.forEach(function($button) {
      $button.addEventListener('click', function(event) {
        event.preventDefault();
        // --
        self._deleteUser($button);
      });
    });
  }
}

export default deleteUserConfirm
